import { FloatingFormItem } from '@/components/_common';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Form, Input, Modal, ModalProps, Row } from 'antd';
import { useEffect } from 'react';
import { ColorResult } from '@uiw/color-convert';
import { CustomerCategoryFormValues } from '@/core/domain/people/CustomerCategory/CustomerCategory.types';
import {
  useCustomerCategoryCreate,
  useCustomerCategoryDetails,
  useCustomerCategoryUpdate,
} from '@/core/domain/people/CustomerCategory/CustomerCategory.hooks';
import SelectCircleColors from '@/components/_common/SelectCircleColors';

interface Props extends Omit<ModalProps, 'onCancel'> {
  categoryId?: number;
  onCancel: VoidFunction;
}

export default function CategoryModal({
  onCancel,
  categoryId,
  ...props
}: Props) {
  const defaultEmptyError = useDefaultEmptyFieldError();
  const [form] = Form.useForm<CustomerCategoryFormValues>();

  const create = useCustomerCategoryCreate();
  const update = useCustomerCategoryUpdate();

  const { data, dataUpdatedAt } = useCustomerCategoryDetails(categoryId);

  function handleCancel() {
    form.resetFields();
    onCancel();
  }

  async function handleOk() {
    const values = await form.validateFields();

    if (data?.id) {
      await update.mutateAsync({ id: data.id, ...values });
    } else {
      await create.mutateAsync(values);
    }

    handleCancel();
  }

  useEffect(() => {
    if (data) {
      form.setFieldsValue(data);
    }
  }, [dataUpdatedAt, props.open]);

  return (
    <Modal
      {...props}
      title={`${!data?.id ? 'Criação' : 'Edição'} da categoria`}
      width={500}
      okText={!data?.id ? 'Criar' : 'Editar'}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={create.isLoading || update.isLoading}
    >
      <Form form={form}>
        <Row gutter={[12, 12]}>
          <Col span={24}>
            <FloatingFormItem
              name="name"
              label="Descrição"
              rules={[defaultEmptyError]}
            >
              <Input maxLength={50} />
            </FloatingFormItem>
          </Col>

          <Form.Item
            name="color"
            label="Cor"
            getValueFromEvent={(e: ColorResult) => {
              return e.hex;
            }}
            rules={[defaultEmptyError]}
            valuePropName="color"
          >
            <SelectCircleColors />
          </Form.Item>
        </Row>
      </Form>
    </Modal>
  );
}
